<template>
    <div>
        <b-row>
            <b-col v-for="item in validation_items" :key="item.id" cols="3">
                <b-card
                :header-class="item.isValid ? 'bg-transparent border-danger' : 'bg-transparent border-success'"
                :class="item.isValid ? 'border-success' : 'border-danger'"
                class="border">
                    <template v-slot:header>
                        <h5 v-if="item.isValid" class="my-0 text-success">
                            <i class="fas fa-thumbs-up me-3"></i>
                            {{item.requirement}}
                        </h5>
                        <h5 v-else class="my-0 text-danger">
                            <i class="fas fa-thumbs-down me-3"></i>
                            {{item.requirement}}
                        </h5>
                    </template>
                    <b-button size="sm" variant="outline-primary" @click="viewStep">View</b-button>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import _ from 'lodash'
import { licenseAppMethods, licenseAppState } from '@/state/helpers';

export default {
    data:() => ({}),
    computed:{
        ...licenseAppState,
        validation_items(){
            let items = _.cloneDeep(this.step_data.validation);
            console.log('STEP DATA', this.step_data);
            if(this.step_data.status != 'pending_validation' && this.step_data.status != 'pending_revalidation'){
                items.forEach((item) => {
                    item.client_validation.every( sub_item => {
                        if(sub_item.validation_status == 'passed'){
                            item['isValid'] = true;
                            return false;
                        }
                        return true;
                    }) 
                })
            }
            return items;
        }
    },
    methods:{
        ...licenseAppMethods,
        viewStep(){
            this.$eventHub.$emit('showFormTab');
        }
    },
    mounted(){},
}
</script>

<style>

</style>